import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { useHubCardLivePreview } from "src/hooks/useHubCardLivePreview";
import {
  isMeaningfulRestaurantPromo,
  mapRestaurantPromoDoc,
} from "src/utils/mapRestaurantPromo";
import { restaurantPromoLivePreviewRequestHandler } from "src/utils/restaurantPromoLivePreviewHandler";
import DynamicDiningPromo from "src/pages/promotions/dining/DynamicDiningPromo";

/**
 * Payload Live Preview iframe target for `restaurant-promotions`.
 * Always enabled (`forceEnabled`) so CMS editors see drafts without the flag.
 */
const RestaurantPromoPreview = () => {
  const { t, i18n } = useTranslation();
  const { card: page, isLoading } = useHubCardLivePreview(
    "restaurant-promotions",
    {
      depth: 2,
      mapDoc: mapRestaurantPromoDoc,
      requestHandler: restaurantPromoLivePreviewRequestHandler,
      forceEnabled: true,
    },
    i18n.language,
  );

  if (isLoading) {
    return (
      <PreviewStatus>
        <Spinner animation="border" variant="light" role="status">
          <span className="visually-hidden">{t("loading")}</span>
        </Spinner>
      </PreviewStatus>
    );
  }

  if (!isMeaningfulRestaurantPromo(page)) {
    return (
      <PreviewStatus>
        <p>{t("diningPromo.preview.waitingForDocument", "Waiting for document…")}</p>
      </PreviewStatus>
    );
  }

  const promo = (
    <DynamicDiningPromo
      promoData={page}
      scheduleKeyName={page.unpublishAt ? undefined : page.promotionKey}
      unpublishAt={page.unpublishAt}
      theme={page.theme}
    />
  );

  return (
    <PreviewShell>
      {page.promotionKey === "earlyBirdBreakfastSpecial" ? (
        <EarlyBirdShell>{promo}</EarlyBirdShell>
      ) : (
        promo
      )}
    </PreviewShell>
  );
};

const PreviewStatus = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--black);
  color: var(--mutedwhite);
  text-align: center;
  padding: 2rem;
`;

const PreviewShell = styled.div`
  .hero_container {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
`;

const EarlyBirdShell = styled.div`
  .hero_container {
    min-height: 0;
  }
  .hero_image_container {
    padding: 1.5rem 1rem 1rem;
  }
  .hero_image {
    max-width: 220px !important;
    width: auto;
    margin: 0 auto;
    padding: 0 !important;
    @media (min-width: 768px) {
      max-width: 280px !important;
    }
    img {
      max-height: 220px;
      width: auto;
      margin: 0 auto;
      @media (min-width: 768px) {
        max-height: 280px;
      }
    }
  }
`;

export default RestaurantPromoPreview;
